// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__cbMKz","tab":"ProcedureTabs_tab__14c9b"};